// import { combineReducers, configureStore } from '@reduxjs/toolkit';
// import { setupListeners } from '@reduxjs/toolkit/query';
// import { homeSlice } from '../slices/homeSlice';
// import { blogSlice } from '../slices/blogSlice';
// import wishlistReducer from '../slices/wishlistSlice';
// import myBagReducer from "../slices/myBagSlice";
// import myBagToggleReducer from "../slices/myBagToggleSlice";
// import recentProductsReducer from '../slices/recentProductsSlice';
// import storage from 'redux-persist/lib/storage'; 
// import { persistStore, persistReducer } from 'redux-persist';

// const persistConfig = {
//   key: 'root',
//   storage,
//   whitelist: ['wishlist', 'myBagData', 'myBagToggle'], 
// };

// const rootReducer = combineReducers({
//   wishlist: wishlistReducer,
//   myBagData: myBagReducer,
//   myBagToggle: myBagToggleReducer,
//   recentProducts: recentProductsReducer,
//   [homeSlice.reducerPath]: homeSlice.reducer,
//   [blogSlice.reducerPath]: blogSlice.reducer,
// });

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }).concat(homeSlice.middleware, blogSlice.middleware),
// });

// export const persistor = persistStore(store);

// setupListeners(store.dispatch);




import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { homeSlice } from '../slices/homeSlice';
import { blogSlice } from '../slices/blogSlice';
import wishlistReducer from '../slices/wishlistSlice';
import myBagReducer from "../slices/myBagSlice";
import myBagToggleReducer from "../slices/myBagToggleSlice";
import recentProductsReducer from '../slices/recentProductsSlice';
import storage from 'redux-persist/lib/storage'; 
import { persistStore, persistReducer } from 'redux-persist';
import { bagPdfSlice } from '../slices/bagPdfSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['wishlist', 'myBagData', 'myBagToggle'], 
};

const rootReducer = combineReducers({
  wishlist: wishlistReducer,
  myBagData: myBagReducer,
  myBagToggle: myBagToggleReducer,
  recentProducts: recentProductsReducer,
  [homeSlice.reducerPath]: homeSlice.reducer,
  [blogSlice.reducerPath]: blogSlice.reducer,
  [bagPdfSlice.reducerPath]: bagPdfSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      homeSlice.middleware, 
      blogSlice.middleware, 
      bagPdfSlice.middleware 
    ),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
